import { NewFeature } from '@app/models/new-feature/new-feature.model';

export const mockNewFeatures: NewFeature[] = [

];